import React, { useEffect } from "react";
import styled from "styled-components";
import { useSearchParams, useNavigate } from "react-router-dom";
import { FaTimesCircle, FaRedo } from "react-icons/fa";
import { cancelPendingOrder } from "../utils/api";

const Cancelled = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const sessionId = searchParams.get("session_id");

    useEffect(() => {
        const cancelOrder = async () => {
            await cancelPendingOrder(sessionId);
        };
        if (!sessionId) {
            navigate("/");
        } else {
            cancelOrder();
        }
    }, [sessionId, navigate]);


    return (
        <Container>
            <MessageBox>
                <CancelIcon>
                    <FaTimesCircle />
                </CancelIcon>
                <h1>Betaling Avbrutt</h1>
                <p>Din betaling ble ikke fullført. Ønsker du å prøve igjen?</p>

                <BackButton onClick={() => navigate("/checkout")}>
                    <FaRedo /> Prøv Igjen
                </BackButton>
            </MessageBox>
        </Container>
    );
};

export default Cancelled;

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-top: 35px;
    animation: fade-in 1s ease-in-out;
    min-height: 100vh;
`;

const MessageBox = styled.div`
    background: white;
    padding: 30px;
    text-align: center;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(255, 0, 0, 0.2);
    width: 90%;
    max-width: 500px;
    animation: slide-up 0.6s ease-in-out;
`;

const CancelIcon = styled.div`
    font-size: 50px;
    color: #e63946;
    margin-bottom: 10px;
`;

const BackButton = styled.button`
    background: #e63946;
    color: white;
    border: none;
    padding: 10px 20px;
    margin-top: 20px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
    transition: background 0.3s ease-in-out;

    &:hover {
        background: #c62828;
    }
`;
